import Calendar from "./CalendarPollution";
import { TabProps } from "../components/Switches";
import { Box, styled } from "@mui/material";
import Zone from "./Zone";
import { PolutionPicIcon } from "src/assets/icons";

const PollutionSensor: React.FC<TabProps> = (props: TabProps) => {
  return (
    <Box>
      <PollutionBlockStyled>
        <Zone
          tab={props.tab}
          setTab={props.setTab}
          name="Pollution"
          image={<PolutionPicIcon />}
          type="pollution"
        />
        <Calendar />
      </PollutionBlockStyled>
    </Box>
  );
};

const PollutionBlockStyled = styled(Box)(({ theme }) => ({
  display: "flex",
  [theme.breakpoints.down("sm")]: {
    flexDirection: "column",
  },
}));

export default PollutionSensor;
